import React from "react"
import RulesList from "./RulesList"
import { Container,
  Content,
  Header,
  Logo,
  ModeLogo,
  QuizTagline,
  QuizTitle } from "./styled"

const GameRules = ({
  bannerImage,
  colors,
  gameMode,
  quizTagline,
  quizTitle,
  rules,
  logoIsVisible,
  fonts
}) => (
  <Container
    bgColor={colors.primary}
    hasEvenlyRoundedCorners={!logoIsVisible}
  >
    <Logo>
      <img src={bannerImage} />
    </Logo>

    <Content>
      <Header fontColor={colors.primaryFont}>
        <QuizTitle>
          { quizTitle }
        </QuizTitle>
        <QuizTagline>
          { quizTagline }
        </QuizTagline>
      </Header>

      <RulesList
        bgColor={colors.secondary}
        fontColor={colors.secondaryFont}
        hasEvenlyRoundedCorners={!logoIsVisible}
        gameMode={"Punkte"}
        rules={rules}
        fonts={fonts}
      />
      <ModeLogo isVisible={logoIsVisible}/>
    </Content>

  </Container>

)

export default GameRules
